import type { IGenericTableData } from '@/interfaces/powerMarkets/table/IGenericTableData.ts';
import type { IGenericTableHeaderRow } from '@/interfaces/powerMarkets/table/IGenericTableHeaderRow.ts';
import type { IGenericTableRowFormatting } from '@/interfaces/powerMarkets/table/IGenericTableRowFormatting.ts';
import { createDefaultFilterProperty } from './tableFilterColumnsFromData.ts';

type TGenericTableColumn = Pick<IGenericTableHeaderRow, 'id' | 'title'> & Partial<IGenericTableHeaderRow>;

export function buildGenericTableData (
    columns: Array<TGenericTableColumn>,
    rows: Array<Array<string | number | null | undefined | IGenericTableRowFormatting>>,
): IGenericTableData {
    return {
        headerFirstRowById: Object.fromEntries(columns.map(column => [column.id, {
            hoverText: null,
            isHeaderParent: false,
            allowSort: true,
            allowFilter: true,
            allowWrap: false,
            borderRight: null,
            convertCellValueToDuration: false,
            firstRowHasBeenSet: true,
            ignoreBrackets: false,
            isMw: false,
            isPlant: false,
            multipleUnits: false,
            noExcel: false,
            parentHeaderId: null,
            prefix: null,
            prefixOverrideWhenInHeader: null,
            rowSpan: 1,
            selected: false,
            showUnitsEvenWhenInHeader: false,
            suffix: null,
            suffixOverrideWhenInHeader: null,
            ...column,
        } satisfies IGenericTableHeaderRow])),
        data: rows.map((values, index) => ({
            row: Object.fromEntries(columns.map((column, columnIndex) => {
                const cell = values[columnIndex];
                return [column.id, cell !== null && typeof cell === 'object' ? cell : {
                    ...createDefaultFilterProperty(typeof cell === 'number' ? 'number' : 'text'),
                    values: [cell ?? null],
                }];
            })),
            uniqueId: String(index),
            clickEventUrl: null,
            extraInfo: [],
            flash: false,
            hoverOver: null,
            selected: false,
            type: '',
            alternativeHiddenString: '',
        })),
        headerToSort: null,
        tabName: '',
        type: 'table',
    };
}
